import { createAction, props } from '@ngrx/store';

export const setPreferenceIndicesCalcs = createAction(
    '[Indices Edit Columns Modal] Set Preference Indices Calcs',
    props<{ calcs: string[] }>()
);
